import { useContext } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import ModalFooterMobile from '@wix/da-ds/pkg/modals/dsPresets/ModalFooterMobile';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import BitPayPaymentTerms from '../../_partials/BitPayPaymentTerms';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './BitPayWithdrawConfirmationModal.scss';

export interface Props {
  isOpen: boolean;
  requestClose: () => void;
  onDone?: () => void;
}

const BitPayWithdrawConfirmationModal: FC<Props> = ({
  isOpen,
  requestClose,
  onDone,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  const handleDone = () => {
    onDone?.();
    requestClose();
  };

  return (
    <Modal
      className={s['wrapper']}
      contentClassName={s['content']}
      heading={t('studio.earnings.bitpay.withdraw.confirmation.title')}
      onRequestClose={requestClose}
      showHeaderBorder
      showFooterBorder
      shouldCloseOnOverlayClick
      isOpen={isOpen}
      withScrollableContentWrapper
      footerRight={[
        <BrandedButton
          onClick={handleDone}
          size="large"
          variant="brand-green"
          key="done"
        >
          {t('common.gotIt')}
        </BrandedButton>,
      ]}
      footerPadding={isMobile ? 'none' : undefined}
      footer={
        isMobile ? (
          <ModalFooterMobile
            primaryButton={
              <BrandedButton
                fillContainerWidth={true}
                onClick={handleDone}
                size="large"
                variant="brand-green"
                key="done"
              >
                {t('common.gotIt')}
              </BrandedButton>
            }
          />
        ) : undefined
      }
    >
      <div className={s['subtitle']}>
        {t('studio.earnings.bitpay.withdraw.confirmation.subtitle')}
      </div>

      <div className={s['description']}>
        {t('studio.earnings.bitpay.withdraw.confirmation.description')}
      </div>

      <BitPayPaymentTerms className={s['terms-block']} />
    </Modal>
  );
};

BitPayWithdrawConfirmationModal.displayName = 'BitPayWithdrawConfirmationModal';

export default BitPayWithdrawConfirmationModal;
